import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { TrustBar } from '../components/TrustBar';
import { OrganizerBenefits } from '../components/OrganizerBenefits';
import { HowItWorks } from '../components/HowItWorks';
import { FeaturedTrips } from '../components/FeaturedTrips';
import { WhyPremier } from '../components/WhyPremier';
import { Testimonials } from '../components/Testimonials';
import { FAQ } from '../components/FAQ';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function Homepage() {
  return <div className="min-h-screen bg-white" data-id="element-285">
      <Header data-id="element-286" />
      <main data-id="element-287">
        <Hero data-id="element-288" />
        <TrustBar data-id="element-289" />
        <OrganizerBenefits data-id="element-290" />
        <HowItWorks data-id="element-291" />
        <FeaturedTrips data-id="element-292" />
        <WhyPremier data-id="element-293" />
        <Testimonials data-id="element-294" />
        <FAQ data-id="element-295" />
        <FinalCTA data-id="element-296" />
      </main>
      <Footer data-id="element-297" />
    </div>;
}